import { Divider, Flex, Space } from 'antd';
import React, { CSSProperties } from 'react';

type ChartContentProps = {
  contentList?: ChartContentListProps;
};

type ChartContentListProps = {
  items?: ChartContentItemProps[];
  styles?: CSSProperties;
};

type ChartContentItemProps = {
  title: string;
  value: string;
  styles?: CSSProperties;
};

const ChartContent: React.FC<ChartContentProps> = (props) => {
  const { contentList } = props;

  const contentTitleStyles: CSSProperties = {
    textAlign: 'left',
    display: 'inline-block',
  };

  const contentValueStyles: CSSProperties = {
    textAlign: 'right',
    display: 'inline-block',
    marginLeft: 6,
  };

  const contentContainerStyles: CSSProperties = {
    padding: '4px 12px',
    // borderTop: '1px solid #eee',
    borderBottom: '1px solid #eee',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  };

  const mergeStyles = (source: CSSProperties, target?: CSSProperties) => {
    return { ...source, ...(target || {}) };
  };

  return (
    <>
      {contentList && contentList.items ? (
        <div style={mergeStyles({}, contentList.styles)}>
          <Space style={{ width: '100%' }} styles={{ item: { flex: 1 } }} split={<Divider type="vertical" />}>
            {contentList.items.map((content, index) => (
              <div key={index} style={{ ...contentContainerStyles }}>
                <span style={mergeStyles(contentTitleStyles, content.styles)}>{content.title}:</span>
                <span style={mergeStyles(contentValueStyles, content.styles)}>{content.value}</span>
              </div>
            ))}
          </Space>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default ChartContent;
